import { min, max } from "lodash-es";
import { useState, useEffect } from "react";
import { WebMercatorViewport } from "react-map-gl";
import { ICoordinate, IMarker } from "shared/types";

export const useGetBounds = (markers?: IMarker[]) => {
  const [coordinates, setCoordinates] = useState<ICoordinate | null>(null);
  const [zoom, setZoom] = useState<number | null>(null);
  const [fitBoundsOnce, setFitBoundsOnce] = useState(false);

  useEffect(() => {
    if (fitBoundsOnce) return;
    if (!markers?.length) return;

    const pointsLong = markers.map(
      ({ coordinates: { longitude } }) => longitude
    );
    const pointsLat = markers.map(({ coordinates: { latitude } }) => latitude);
    const cornersLongLat: [[number, number], [number, number]] = [
      [min(pointsLong) as number, min(pointsLat) as number],
      [max(pointsLong) as number, max(pointsLat) as number],
    ];

    // TODO: get map width/height
    const viewport = new WebMercatorViewport({
      width: 640,
      height: 300,
    }).fitBounds(cornersLongLat, { padding: 50 });

    setCoordinates({
      latitude: viewport.latitude,
      longitude: viewport.longitude,
    });
    setZoom(viewport.zoom);
    setFitBoundsOnce(true);
  }, [markers, fitBoundsOnce]);

  return { coordinates, zoom };
};
